export default function BlueBtnLink({href, text}) {
  return (
    <a href={href} target="_blank" rel="noreferrer" className="bg-gradient-to-br from-blue-400 via-blue-600 to-blue-600 hover:from-blue-400 hover:via-blue-500 hover:to-blue-600 text-white py-2 px-5 mt-3 rounded-md">{text}</a>
  )
}